export default "__VITE_ASSET__1083570b__"